import {
    Box,
    Button,
    Heading,
    Stack,
    Text,
    ThemeBorderVariable,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeRadiusVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useBookingIdParam } from "hooks/use-booking-id-param";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Routes } from "routes";

/**
 * Shown on the my-booking page when the guest has been sent a menu proposal they have not yet
 * answered (MenuStatus.Sent). Navigates them to the dedicated menu-select page.
 */
const MenuProposalCta = () => {
    const { t } = useTranslation();
    const { system } = useParams();
    const bookingId = useBookingIdParam();
    const navigate = useNavigate();

    if (!system) {
        return null;
    }

    const goToMenuSelect = () => {
        void navigate(`/${Routes.BOOKING}/${system}/${bookingId}/${Routes.MENU_SELECT}`);
    };

    return (
        <Box
            border={ThemeBorderVariable.XSmall}
            borderColor={ThemeColorVariable.OnBackgroundBorder}
            borderRadius={ThemeRadiusVariable.Medium}
            bg={ThemeColorVariable.Surface}
            p={ThemeSpaceVariable.Medium}
        >
            <Stack spacing={ThemeSpaceVariable.Small}>
                <Heading
                    as="h3"
                    fontSize={ThemeFontSizeVariable.Large}
                    fontWeight="500"
                    color={ThemeColorVariable.OnSurfaceHeader}
                >
                    {t("menuProposal.title")}
                </Heading>
                <Text color={ThemeColorVariable.OnSurfaceSubdued}>
                    {t("menuProposal.description")}
                </Text>
                <Button
                    variant="primary"
                    size="xl"
                    w="full"
                    onClick={goToMenuSelect}
                    data-track-click="mybooking-menu-proposal"
                >
                    {t("menuProposal.cta")}
                </Button>
            </Stack>
        </Box>
    );
};

export default MenuProposalCta;
